<template>
  <div class="galvanometer-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>τ = N · B · I · A | θ ∝ I$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Magnets (Radical Field) -->
          <path d="M 50,40 A 100,100 0 0 1 50,200" fill="#ff4757" opacity="0.2" stroke="#ff4757" stroke-width="2" />
          <path d="M 350,40 A 100,100 0 0 0 350,200" fill="#00d2ff" opacity="0.2" stroke="#00d2ff" stroke-width="2" />
          <text x="30" y="35" fill="#ff4757" font-size="12">N</text>
          <text x="350" y="35" fill="#00d2ff" font-size="12">S</text>

          <!-- The Scale -->
          <path d="M 120,60 A 80,80 0 0 1 280,60" fill="none" stroke="#555" stroke-dasharray="2,5" />
          <text v-for="i in 5" :key="i" :x="120 + i*32" y="50" fill="#888" font-size="8">{{ (i-3)*10 }}</text>

          <!-- Iron Core and Coil -->
          <circle cx="200" cy="140" r="30" fill="#444" stroke="#888" />
          <g :transform="`rotate(${deflection}, 200, 140)`">
             <!-- The Coil -->
             <rect x="-35" y="-10" width="70" height="20" fill="none" stroke="#ffd700" stroke-width="3" rx="4" />
             <!-- The Needle -->
             <line x1="0" y1="0" x2="0" y2="-90" stroke="#ff4757" stroke-width="2" />
             <path d="M -5,-80 L 0,-95 L 5,-80 Z" fill="#ff4757" />
          </g>

          <!-- Hairspring (Visual) -->
          <path d="M 210,140 Q 220,130 210,120 Q 200,110 210,100" fill="none" stroke="#888" opacity="0.5" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>输入电流 I: {{ current.toFixed(1) }} mA</label>
              <div class="value">偏转角 θ ≈ {{ deflection.toFixed(1) }}°</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节输入电流 I</label>
             <el-slider v-model="current" :min="-20" :max="20" step="0.5" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>磁电式电流计（表头）核心是一组位于辐向均匀磁场中的**通电线圈**。根据安培力定律，电流越大，磁场对线圈产生的转矩 $\tau$ 越大。这种转矩与螺旋弹簧产生的弹性回复力矩相平衡，导致指针偏转角与电流强度成**正比**。这就是线性刻度的由来。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalvanometerViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      current: 0
    }
  },
  computed: {
    deflection() {
       return this.current * 3; // Sensitivity factor
    }
  }
}
</script>

<style scoped lang="scss">
.galvanometer-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
